import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, TextInput, Colors } from 'advenio-components'
import { Form } from 'formsy-react-2'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'
import Api from '../../../Data/Api'

var Container = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;
`

var LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

var RightPanel = styled.div`
  width: 260px;
  border-left: 1px solid ${Colors.gray200};
  padding-left: 16px;
  display: flex;
  flex-direction: column;
`

var TabsContainer = styled.div`
  display: flex;
  border-bottom: 2px solid ${Colors.gray200};
  margin-bottom: 16px;
`

var Tab = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: ${function (props) { return props.active ? Colors.blue500 : '#637381' }};
  border-bottom: 2px solid ${function (props) { return props.active ? Colors.blue500 : 'transparent' }};
  margin-bottom: -2px;
  &:hover {
    color: ${Colors.blue500};
  }
`

var SearchRow = styled.div`
  display: inline-flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 12px;
`

var InputWrapper = styled.div`
  width: 240px;
`

var ResultsList = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 280px;
  border: 1px solid ${Colors.gray200};
  border-radius: 4px;
`

var ResultItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid ${Colors.gray200};
  &:last-child {
    border-bottom: none;
  }
`

var StudentName = styled.span`
  font-size: 14px;
  color: #212B36;
`

var StudentMeta = styled.span`
  font-size: 12px;
  color: #637381;
`

var AddButton = styled.span`
  font-size: 12px;
  color: ${Colors.blue500};
  cursor: pointer;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
`

var SelectedTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212B36;
  margin-bottom: 8px;
`

var Counter = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${Colors.blue500};
  margin-bottom: 12px;
`

var SelectedList = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 320px;
`

var SelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-bottom: 1px solid ${Colors.gray200};
  &:last-child {
    border-bottom: none;
  }
`

var SelectedName = styled.span`
  font-size: 13px;
  color: #212B36;
`

var RemoveButton = styled.span`
  font-size: 16px;
  color: #E53935;
  cursor: pointer;
  font-weight: 700;
  line-height: 1;
  &:hover {
    opacity: 0.7;
  }
`

var NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  color: #637381;
  font-size: 14px;
`

var ClassroomItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid ${Colors.gray200};
  cursor: pointer;
  &:hover {
    background: #F5F6FA;
  }
  &:last-child {
    border-bottom: none;
  }
`

var ClassroomName = styled.span`
  font-size: 14px;
  color: #212B36;
  font-weight: 500;
`

var HintText = styled.p`
  font-size: 13px;
  color: #637381;
  margin: 0 0 12px 0;
`

var TABS = {
  INDIVIDUAL: 'individual',
  CLASSROOM: 'classroom'
}

class Step2SelectStudents extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeTab: TABS.INDIVIDUAL,
      searchTerm: '',
      searchResults: [],
      classrooms: [],
      loadingClassrooms: false
    }
  }

  componentDidMount () {
    this.loadClassrooms()
  }

  loadClassrooms = () => {
    var centerId = this.props.centerId
    if (!centerId) return
    var self = this
    self.setState({ loadingClassrooms: true })
    Api.centerClassroom.get(centerId)
      .then(function (response) {
        var data = response.data.data || response.data || []
        self.setState({ classrooms: data, loadingClassrooms: false })
      })
      .catch(function () {
        self.setState({ loadingClassrooms: false })
      })
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab })
  }

  handleSearch = (formData) => {
    var name = (formData.search || '').toLowerCase()
    this.setState({ searchTerm: formData.search || '' })

    if (name.length < 2) {
      this.setState({ searchResults: [] })
      return
    }

    // Search locally from loaded classrooms
    var results = []
    var classrooms = this.state.classrooms
    for (var i = 0; i < classrooms.length; i++) {
      var students = classrooms[i].students || []
      for (var j = 0; j < students.length; j++) {
        var s = students[j]
        var fullName = ((s.first_name || '') + ' ' + (s.last_name_paternal || '') + ' ' + (s.last_name_maternal || '')).toLowerCase()
        if (fullName.indexOf(name) > -1) {
          results.push({ student: s, classroom: classrooms[i].name })
        }
      }
    }
    this.setState({ searchResults: results })
  }

  handleAddStudent = (student) => {
    var studentData = student.student || student
    this.props.selectStudent({
      id: studentData.id,
      name: (studentData.first_name || '') + ' ' + (studentData.last_name_paternal || '') + ' ' + (studentData.last_name_maternal || ''),
      classroom: student.classroom || studentData.classroom || ''
    })
  }

  handleRemoveStudent = (studentId) => {
    this.props.deselectStudent(studentId)
  }

  handleAddClassroom = (classroom) => {
    var students = classroom.students || []
    var mappedStudents = students.map(function (s) {
      return {
        id: s.id,
        name: (s.first_name || '') + ' ' + (s.last_name_paternal || '') + ' ' + (s.last_name_maternal || ''),
        classroom: classroom.name || ''
      }
    })
    if (mappedStudents.length > 0) {
      this.props.selectStudents(mappedStudents)
    }
  }

  isStudentSelected = (studentId) => {
    var selected = this.props.selectedStudents
    for (var i = 0; i < selected.length; i++) {
      if (selected[i].id === studentId) return true
    }
    return false
  }

  renderIndividualTab = () => {
    var self = this
    var results = this.state.searchResults

    return (
      <div>
        <HintText>Busca estudiantes del centro por nombre (mínimo 2 caracteres)</HintText>
        <SearchRow>
          <Form onSubmit={this.handleSearch}>
            <div style={{ display: 'inline-flex', alignItems: 'flex-end', gap: '8px' }}>
              <InputWrapper>
                <TextInput
                  name='search'
                  label='Nombre del estudiante'
                  value={this.state.searchTerm}
                />
              </InputWrapper>
              <Button primary small type='submit'>
                Buscar
              </Button>
            </div>
          </Form>
        </SearchRow>
        <ResultsList>
          {results.length === 0 && this.state.searchTerm.length >= 2 && (
            <NoResults>No se encontraron estudiantes</NoResults>
          )}
          {results.map(function (result) {
            var student = result.student || result
            var alreadySelected = self.isStudentSelected(student.id)
            return (
              <ResultItem key={student.id}>
                <div>
                  <StudentName>
                    {(student.first_name || '') + ' ' + (student.last_name_paternal || '')}
                  </StudentName>
                  {result.classroom && (
                    <StudentMeta>{' · ' + result.classroom}</StudentMeta>
                  )}
                </div>
                {!alreadySelected && (
                  <AddButton onClick={function () { self.handleAddStudent(result) }}>
                    + Agregar
                  </AddButton>
                )}
                {alreadySelected && (
                  <StudentMeta>Seleccionado</StudentMeta>
                )}
              </ResultItem>
            )
          })}
        </ResultsList>
      </div>
    )
  }

  renderClassroomTab = () => {
    var self = this
    var classrooms = this.state.classrooms
    var loading = this.state.loadingClassrooms

    return (
      <div>
        <HintText>Selecciona una sala para agregar todos sus estudiantes</HintText>
        <ResultsList>
          {loading && <NoResults>Cargando salas...</NoResults>}
          {!loading && classrooms.length === 0 && (
            <NoResults>No hay salas disponibles</NoResults>
          )}
          {!loading && classrooms.map(function (classroom) {
            var studentCount = classroom.students ? classroom.students.length : 0
            return (
              <ClassroomItem
                key={classroom.id}
                onClick={function () { self.handleAddClassroom(classroom) }}
              >
                <ClassroomName>{classroom.name}</ClassroomName>
                <StudentMeta>{studentCount + ' estudiantes'}</StudentMeta>
              </ClassroomItem>
            )
          })}
        </ResultsList>
      </div>
    )
  }

  renderTabContent = () => {
    var activeTab = this.state.activeTab
    if (activeTab === TABS.INDIVIDUAL) return this.renderIndividualTab()
    if (activeTab === TABS.CLASSROOM) return this.renderClassroomTab()
    return null
  }

  render () {
    var selectedStudents = this.props.selectedStudents
    var activeTab = this.state.activeTab
    var self = this

    return (
      <Container>
        <LeftPanel>
          <TabsContainer>
            <Tab
              active={activeTab === TABS.INDIVIDUAL}
              onClick={function () { self.handleTabChange(TABS.INDIVIDUAL) }}
            >
              Individual
            </Tab>
            <Tab
              active={activeTab === TABS.CLASSROOM}
              onClick={function () { self.handleTabChange(TABS.CLASSROOM) }}
            >
              Por Sala
            </Tab>
          </TabsContainer>
          {this.renderTabContent()}
        </LeftPanel>
        <RightPanel>
          <SelectedTitle>Estudiantes seleccionados</SelectedTitle>
          <Counter>
            {selectedStudents.length + ' estudiante' + (selectedStudents.length !== 1 ? 's' : '')}
          </Counter>
          <SelectedList>
            {selectedStudents.length === 0 && (
              <NoResults>Ningún estudiante seleccionado</NoResults>
            )}
            {selectedStudents.map(function (student) {
              return (
                <SelectedItem key={student.id}>
                  <SelectedName>{student.name}</SelectedName>
                  <RemoveButton
                    onClick={function () { self.handleRemoveStudent(student.id) }}
                    title='Quitar'
                  >
                    ×
                  </RemoveButton>
                </SelectedItem>
              )
            })}
          </SelectedList>
        </RightPanel>
      </Container>
    )
  }
}

Step2SelectStudents.propTypes = {
  selectedStudents: PropTypes.array,
  centerId: PropTypes.number,
  selectStudent: PropTypes.func.isRequired,
  deselectStudent: PropTypes.func.isRequired,
  selectStudents: PropTypes.func.isRequired
}

Step2SelectStudents.defaultProps = {
  selectedStudents: [],
  centerId: null
}

var mapStateToProps = function (state) {
  return {
    selectedStudents: state.documents.wizard.selectedStudents,
    centerId: state.auth.user.center_id
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    selectStudent: function (student) {
      return dispatch(DocumentsActions.selectStudent(student))
    },
    deselectStudent: function (studentId) {
      return dispatch(DocumentsActions.deselectStudent(studentId))
    },
    selectStudents: function (students) {
      return dispatch(DocumentsActions.selectStudents(students))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step2SelectStudents)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DistributeWizard/Step2SelectStudents.jsx